module.exports = __webpack_public_path__ + "static/media/loanPayment.4d363199.svg";